import { Box, Container, Flex, Heading, Text, Image, Button, Center, Avatar, HStack, useDisclosure, Spinner, Grid, GridItem, VStack, IconButton, Progress, ButtonGroup } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingScreen from "components/loading-screen";
import VideoPlayer from "components/video-player";
import ProgramService from "services/programs/program-service";
import LayoutProgramLesson from "scenes/layouts/layout-program-lesson";
import ConfirmDialog from "components/confirm-dialog";
import LogosNotification from "../../../utils/notification-utils";
import { BsCameraVideo, BsImage, BsPencil, BsXCircle } from "react-icons/bs";
import EditImageDialog from "../../../components/edit-image-dialog";
import UploadVideoDialog from "../../../components/upload-video-dialog";
import { FaBug, FaHourglassHalf } from "react-icons/fa";
import AddLessonResourceDialog from "./add-resourse";
import RemoveLessonResourceDialog from "./remove-resource";
import MoveLessonGroupDialog from "./move-group";

const initialLesson = {
    title: '',
    subTitle: '',
    description: '',
    posterUrl: '',
    videoUrl: '',
    isCompleted: false,
    isSubscribed: false,
    resources: []
};

const ProgramLesson = (): ReactElement => {
    const navigate = useNavigate();
    const [lesson, setLesson] = useState<any>(initialLesson);
    const [program, setProgram] = useState<any>(null);
    const [lessonGroup, setLessonGroup] = useState<any>(null);
    const [videoUploadQueue, setVideoUploadQueue] = useState<any>(null);
    const [isLoading, setLoading] = useState<boolean>(true);
    const { programId, lessonGroupId, lessonId }: any = useParams();
    const { isOpen: isShowActivateDialog, onOpen: onShowActivateDialog, onClose: onCloseActivateDialog } = useDisclosure();
    const { isOpen: isShowDeActivateDialog, onOpen: onShowDeActivateDialog, onClose: onCloseDeActivateDialog } = useDisclosure();
    const { isOpen: isShowDeleteLessonDialog, onOpen: onShowDeleteLessonDialog, onClose: onCloseDeleteLessonDialog } = useDisclosure();
    const { isOpen: isShowChangePosterDialog, onOpen: onShowChangePosterDialog, onClose: onCloseChangePosterDialog } = useDisclosure();
    const { isOpen: isShowUploadVideoDialog, onOpen: onShowUploadVideoDialog, onClose: onCloseUploadVideoDialog } = useDisclosure();
    const { isOpen: isShowDeleteVideoDialog, onOpen: onShowDeleteVideoDialog, onClose: onCloseDeleteVideoDialog } = useDisclosure();
    const { isOpen: isShowCreateResourceDialog, onOpen: onShowCreateResourceDialog, onClose: onCloseCreateResourceDialog } = useDisclosure();
    const { isOpen: isShowDeleteResourceDialog, onOpen: onShowDeleteResourceDialog, onClose: onCloseDeleteResourceDialog } = useDisclosure();
    const { isOpen: isShowMoveGroupDialog, onOpen: onShowMoveGroupDialog, onClose: onCloseMoveGroupDialog } = useDisclosure();
    const [isActivating, setIsActivating] = useState<boolean>(false);
    const [isDeActivating, setIsDeActivating] = useState<boolean>(false);
    const [isDeletingVideo, setIsDeletingVideo] = useState<boolean>(false);
    const [isDeletingLesson, setIsDeletingLesson] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);
        ProgramService.GetProgram(programId).then((programResponse: any) => {
            if (!programResponse.result)
                navigate(`/programs/${programId}`);

            setProgram(programResponse.result);

            var lessonGroup = programResponse.result.lessonGroups.find((i: any) => i.id == lessonGroupId);
            setLessonGroup(lessonGroup);

            ProgramService.GetLesson(programId, lessonId).then((response: any) => {
                if (!response.result)
                    navigate(`/programs/${programId}`);

                setLesson(response.result);

                ProgramService.GetLessonVideoUploadQueue(programId, lessonGroupId, lessonId).then((response: any) => {
                    setVideoUploadQueue(response.result);
                }).finally(() => {
                    setLoading(false);
                });
            });
        });
    }, [lessonId]);

    const handleActivate = () => {
        setIsActivating(true);
        ProgramService.ActivateLesson(programId, lessonGroupId, lessonId).then((res: any) => {
            setLesson(res.result);
            onCloseActivateDialog();
            LogosNotification.Success("Lesson berhasil di aktifkan.");
        }).finally(() => {
            setIsActivating(false);
        });
    };

    const handleDeActivate = () => {
        setIsDeActivating(true);
        ProgramService.DeActivateLesson(programId, lessonGroupId, lessonId).then((res: any) => {
            setLesson(res.result);
            onCloseDeActivateDialog();
            LogosNotification.Success("Lesson berhasil di non-aktifkan.");
        }).finally(() => {
            setIsDeActivating(false);
        });
    };

    const handleChangePoster = (imageData: any, finallyFunction: any) => {
        ProgramService.ChangeLessonPosterImage(programId, lessonGroupId, lessonId, imageData).then((res: any) => {
            onCloseChangePosterDialog();
            setLesson(res.result);
            LogosNotification.Success("Poster Lesson telah berhasil diperbaharui.");
        }).finally(() => {
            finallyFunction();
        });
    };

    const handleUploadVideoChunk = (chunk: any, counter: number, filename: string) => {
        return ProgramService.UploadVideoLessonChunk(programId, lessonGroupId, lessonId, chunk, counter, filename);
    };

    const handleUploadVideoComplete = (chunkId: string, fileName: string, fileSize: number) => {
        return ProgramService.UploadVideoLessonComplete(programId, lessonGroupId, lessonId, chunkId, fileName, fileSize);
    };

    const handleDeleteVideo = () => {
        setIsDeletingVideo(true);
        ProgramService.DeleteVideoLesson(programId, lessonGroupId, lessonId).then((res: any) => {
            onCloseDeleteVideoDialog();
            LogosNotification.Success("Video Lesson berhasil dihapus.");
            window.location.reload();
        }).finally(() => {
            setIsDeletingVideo(false);
        });
    };

    const handleDeleteLesson = () => {
        setIsDeletingLesson(true);
        ProgramService.DeleteLesson(programId, lessonGroupId, lessonId).then((res: any) => {
            onCloseDeleteLessonDialog();
            LogosNotification.Success("Lesson berhasil dihapus.");
            navigate(`/programs/${programId}`);
        }).finally(() => {
            setIsDeletingLesson(false);
        });
    }

    if (isLoading)
        return <LoadingScreen />;

    else
        return (
            <LayoutProgramLesson title={lesson.title} subtitle={lesson.subTitle} backUrl={`/programs/${programId}`}>
                {/*<Box mt={3}>*/}
                {/*    <Heading textAlign={'center'} fontSize={['sm', 'md', 'lg', 'xl']} fontWeight={'extrabold'}>*/}
                {/*        {lesson.subTitle}*/}
                {/*    </Heading>*/}
                {/*</Box>*/}
                <Box mt={10} px={{ base: '0px', md: '15%' }}>
                    <Box mb={4}>
                        <HStack>
                            <Text>Status:</Text>
                            <Text fontWeight={'bold'} color={lesson.isActive ? "green.600" : "red.500"}>{lesson.isActive ? "Aktif" : "Tidak Aktif"}</Text>
                            {
                                !lesson.isActive &&
                                <Button variant={'solid'} colorScheme={'green'} size={'sm'} onClick={onShowActivateDialog}>Aktifkan</Button>
                            }
                            {
                                lesson.isActive &&
                                <Button variant={'solid'} colorScheme={'red'} size={'sm'} onClick={onShowDeActivateDialog}>Non-Aktifkan</Button>
                            }

                            {
                                isShowActivateDialog &&
                                <ConfirmDialog
                                    title={'Mengaktifkan Lesson'}
                                    message={`Apakah Anda yakin untuk mengaktifkan Lesson ${lesson.title}?`}
                                    colorScheme={'green'}
                                    buttonLabel={'Aktifkan'}
                                    onSubmit={handleActivate}
                                    onClose={onCloseActivateDialog}
                                    isLoading={isActivating}
                                />
                            }
                            {
                                isShowDeActivateDialog &&
                                <ConfirmDialog
                                    title={'Mengnon-aktifkan Lesson'}
                                    message={`Apakah Anda yakin untuk men-nonaktifkan Lesson ${lesson.title}?`}
                                    colorScheme={'red'}
                                    buttonLabel={'Non-Aktifkan'}
                                    onSubmit={handleDeActivate}
                                    onClose={onCloseDeActivateDialog}
                                    isLoading={isDeActivating}
                                />
                            }
                        </HStack>
                        <HStack mt={1}>
                            <Text>Akses:</Text>
                            <Text fontWeight={'bold'} color={lesson.isAllowForPublic ? "red.500" : "green.600"}>{lesson.isAllowForPublic ? "Publik" : "Member"}</Text>
                        </HStack>
                        <HStack mt={1}>
                            <Text>Urutan:</Text>
                            <Text fontWeight={'bold'} >{lesson.sequence}</Text>
                        </HStack>
                        <HStack mt={1}>
                            <Text>Group:</Text>
                            <Text fontWeight={'bold'} >{lessonGroup.title}</Text>
                            <Button mt={2} mr={1} variant={'solid'} colorScheme={'telegram'} size={'sm'} onClick={onShowMoveGroupDialog}>Pindah Group</Button>
                        </HStack>
                    </Box>
                    <Box>
                        {
                            !lesson.isVideo ?
                                <>
                                    <Image src={lesson.posterUrl} rounded={'xl'} />
                                    {/*<AudioPlayer url={lesson.videoUrl} />*/}
                                </>
                                :
                                lesson.posterUrl &&
                                <VideoPlayer options={{
                                    responsive: true,
                                    poster: lesson.posterUrl,
                                    controls: true,
                                    bigPlayButton: true,
                                    playbackRates: [0.75, 1, 1.25, 1.5, 2],
                                    //nativeControlsForTouch: true,
                                    //liveui: true,
                                    fluid: true,
                                    sources: [
                                        {
                                            src: lesson.videoUrl,
                                            type: "application/x-mpegURL"
                                        }
                                    ]
                                }} />
                        }
                        <IconButton
                            variant={"solid"}
                            colorScheme={'blackAlpha'}
                            isRound={true}
                            position={'relative'} bottom={70} ml={1} mb={1}
                            aria-label='Ubah Poster Lesson'
                            icon={<BsImage />}
                            style={{ zIndex: 1 }}
                            onClick={onShowChangePosterDialog}
                        />
                        {
                            isShowChangePosterDialog &&
                            <EditImageDialog onClose={onCloseChangePosterDialog} title="Ubah Poster Lesson" onSubmit={handleChangePoster} aspectRatio={16 / 9} helperText={"Ukuran: 1280 x 720 px"} />
                        }

                        {
                            !(videoUploadQueue && (videoUploadQueue.status == 0 || videoUploadQueue.status == 10)) && !lesson.isVideo &&
                            <IconButton
                                variant={"solid"}
                                colorScheme={'blackAlpha'}
                                isRound={true}
                                position={'relative'} bottom={70} float={'right'} mr={1} mb={1}
                                aria-label='Upload Video'
                                icon={<BsCameraVideo />}
                                style={{ zIndex: 1 }}
                                onClick={onShowUploadVideoDialog}
                            />
                        }
                        {
                            isShowUploadVideoDialog &&
                            <UploadVideoDialog onClose={onCloseUploadVideoDialog} title="Upload Video Lesson" handleUploadChunk={handleUploadVideoChunk} handleUploadComplete={handleUploadVideoComplete} />
                        }

                        {
                            lesson.isVideo &&
                            <IconButton
                                variant={"solid"}
                                colorScheme={'blackAlpha'}
                                isRound={true}
                                position={'relative'} bottom={70} float={'right'} mr={1} mb={1}
                                aria-label='Hapus Video'
                                icon={<BsXCircle />}
                                style={{ zIndex: 1 }}
                                onClick={onShowDeleteVideoDialog}
                            />
                        }
                        {
                            isShowDeleteVideoDialog &&
                            <ConfirmDialog
                                title={'Hapus Video'}
                                message={`Apakah Anda yakin untuk menghapuskan video ini?`}
                                colorScheme={'red'}
                                buttonLabel={'Hapuskan'}
                                onSubmit={handleDeleteVideo}
                                onClose={onCloseDeleteVideoDialog}
                                isLoading={isDeletingVideo}
                            />
                        }
                        {
                            videoUploadQueue && (videoUploadQueue.status == 0 || videoUploadQueue.status == 10) &&
                            <IconButton
                                variant={"solid"}
                                colorScheme={'blackAlpha'}
                                isRound={true}
                                position={'relative'} bottom={70} float={'right'} mr={1} mb={1}
                                aria-label='In Progress Video'
                                icon={<FaHourglassHalf />}
                                style={{ zIndex: 1 }}
                                onClick={() => { alert("Sedang proses Konversi ke File Streaming. Prosesnya memang lumayan lama, Nikmati saja Kopi Susu terlebih dahulu.") }}
                            />
                        }
                        {
                            videoUploadQueue && videoUploadQueue.status == 2 &&
                            <IconButton
                                variant={"solid"}
                                colorScheme={'red'}
                                isRound={true}
                                position={'relative'} bottom={70} float={'right'} mr={1} mb={1}
                                aria-label='Error Upload Video'
                                icon={<FaBug />}
                                style={{ zIndex: 1 }}
                                onClick={() => { alert(videoUploadQueue.message) }}
                            />
                        }
                    </Box>

                </Box>
                <Box mt={0}>
                    <Container maxWidth={"4xl"} mb={10}>
                        <Box className='logos-quill' dangerouslySetInnerHTML={{ __html: lesson.description }}></Box>
                        {
                            lesson.resources.map((resource: any) => {
                                if (resource.type === 0) {
                                    return (
                                        <Box mt={4} bgColor={'gray.200'} rounded={'lg'} p={5}>
                                            <VideoPlayer options={{
                                                responsive: true,
                                                poster: resource.resourcePoster,
                                                sources: [
                                                    {
                                                        src: resource.resourceUrl,
                                                        type: resource.mimeType
                                                    }
                                                ]
                                            }} />
                                            <Text mt={2} fontWeight={"light"} textTransform={"uppercase"}>{resource.resourceTypeName}</Text>
                                            <Heading fontWeight={'bold'} fontSize={"lg"}>{resource.resourceName}</Heading>
                                            <Text>{resource.author}</Text>
                                            <Text mt={2} fontWeight={"light"}>{resource.description}</Text>
                                            <Button mt={2} ml={2} onClick={onShowDeleteResourceDialog} variant={'solid'} colorScheme={'red'}>Hapus</Button>
                                            {
                                                isShowDeleteResourceDialog &&
                                                <RemoveLessonResourceDialog program={program} lessonGroupId={lessonGroupId} lesson={lesson} onClose={onCloseDeleteResourceDialog} resource={resource} />
                                            }
                                        </Box>
                                    )
                                }
                                else {
                                    return (
                                        <Box mt={4} bgColor={'gray.200'} rounded={'lg'} p={3}>
                                            <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(4, 1fr)' }} gap={4}>
                                                <GridItem>
                                                    <Box>
                                                        <Box flex={1}>
                                                            <Image
                                                                src={resource.resourcePoster}
                                                                alt={resource.resourceName}
                                                                objectFit='cover'
                                                                rounded={'lg'}
                                                                boxSize={'200px'}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </GridItem>
                                                <GridItem colSpan={3}>
                                                    <Box>
                                                        <Text fontSize={'sm'} textTransform={"uppercase"}>{resource.resourceTypeName}</Text>
                                                        <Heading fontWeight={'bold'} fontSize={"lg"}>{resource.resourceName}</Heading>
                                                        <Text >{resource.author}</Text>
                                                        <Text mt={3}>{resource.description}</Text>
                                                        <Button mt={2} onClick={() => { window.open(resource.resourceUrl, "_blank") }}>Download</Button>
                                                        <Button mt={2} ml={2} onClick={onShowDeleteResourceDialog} variant={'solid'} colorScheme={'red'}>Hapus</Button>
                                                        {
                                                            isShowDeleteResourceDialog &&
                                                            <RemoveLessonResourceDialog program={program} lessonGroupId={lessonGroupId} lesson={lesson} onClose={onCloseDeleteResourceDialog} resource={resource} />
                                                        }
                                                    </Box>
                                                </GridItem>
                                            </Grid>
                                        </Box>
                                    )
                                }
                            })
                        }
                        <Box my={10}>
                            <Center mt={2}>
                                <Box overflowX={'auto'}>
                                    <ButtonGroup>
                                        <Button variant={'outline'} mt={2} onClick={() => navigate(`/programs/${programId}`)}>Kembali</Button>
                                        <Button mt={2} mr={1} onClick={() => navigate(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}/edit`)}>Edit</Button>
                                        <Button mt={2} mr={1} variant={'solid'} colorScheme={'red'} onClick={onShowDeleteLessonDialog}>Hapus</Button>
                                        <Button mt={2} mr={1} variant={'solid'} colorScheme={'green'} onClick={onShowCreateResourceDialog}>Add Resource</Button>
                                    </ButtonGroup>
                                </Box>
                            </Center>
                        </Box>
                        {
                            isShowDeleteLessonDialog &&
                            <ConfirmDialog
                                title={'Hapus Lesson'}
                                message={`Apakah Anda yakin untuk menghapuskan Lesson ini?`}
                                colorScheme={'red'}
                                buttonLabel={'Hapus'}
                                onSubmit={handleDeleteLesson}
                                onClose={onCloseDeleteLessonDialog}
                                isLoading={isDeletingLesson}
                            />
                        }
                        {
                            isShowCreateResourceDialog &&
                            <AddLessonResourceDialog
                                program={program}
                                lessonGroupId={lessonGroupId}
                                lesson={lesson}
                                onClose={onCloseCreateResourceDialog}
                                onRefreshData={(program: any) => {
                                    onCloseCreateResourceDialog();
                                    LogosNotification.Success("Lesson Resource berhasil ditambahkan.")
                                    window.location.reload();
                                }}
                            />
                        }
                        {
                            isShowMoveGroupDialog &&
                            <MoveLessonGroupDialog lesson={lesson} lessonGroupId={lessonGroupId} program={program} onClose={onCloseMoveGroupDialog} />
                        }
                    </Container>
                </Box>
            </LayoutProgramLesson>
        );
};

export default ProgramLesson;